/**
 * @generated SignedSource<<a4f309125d023fe9404443c5cef911cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DismissibleElementsViewer$data = {
  readonly dismissedElements: ReadonlyArray<{
    readonly dismissedCount: number;
    readonly firstDismissedAt: string | null;
    readonly id: string;
    readonly key: string;
    readonly lastDismissedAt: string | null;
  }>;
  readonly id: string;
  readonly unseenElements: ReadonlyArray<{
    readonly id: string;
    readonly key: string;
    readonly lastAcknowledgedAt: string | null;
    readonly viewsRemaining: number;
  }>;
  readonly user: {
    readonly id: string;
  };
  readonly " $fragmentType": "DismissibleElementsViewer";
};
export type DismissibleElementsViewer$key = {
  readonly " $data"?: DismissibleElementsViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DismissibleElementsViewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./DismissibleElementsViewerRefetchQuery.graphql')
    }
  },
  "name": "DismissibleElementsViewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DismissedElement",
      "kind": "LinkedField",
      "name": "dismissedElements",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstDismissedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastDismissedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dismissedCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnseenElement",
      "kind": "LinkedField",
      "name": "unseenElements",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastAcknowledgedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewsRemaining",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "db215c789983183574745cb3fbb0903b";

export default node;
